import { getLinkParams } from "auth-provider";
import { AuthenticatedApp } from "authenticated-app";
import { ErrorBoundry } from "components/error-boundry";
import { FullPageErrorFallback } from "components/lib";
import { useAuth } from "context/auth-context";
import { FatalError } from "unauthenticated-app";
import "./App.css";

// 根据是否有user属性，来判断展示登录页面还是注册页面
function App() {
  const { restaurant, isValidLink } = useAuth();
  const { orderSource = "" } = getLinkParams();
  const isKioskNotify =
    window.location.pathname === "/notify" && orderSource === "kiosk";
  return (
    <div className={isKioskNotify ? "AppKiosk" : "App"}>
      <ErrorBoundry fallbackRender={FullPageErrorFallback}>
        {/* !user && !isValidLink */}
        {!isValidLink || !restaurant ? (
          <FatalError />
        ) : (
          <AuthenticatedApp />
        )}
      </ErrorBoundry>
    </div>
  );
}

export default App;
